import keys from 'lodash/keys';
import isEmpty from 'lodash/isEmpty';
import { isTakeActionInput } from '../../lib/apiKeys';
import numericInput from '../../lib/numericInput';
import { computeUserFootprint, computeTakeActionResults } from './computeResults';

/**
 * Updates state.user_footprint.inputs and then calls computeUserFootprint.
 * @param {Object.<String, String|Number>} params keys are footprint input suffixes.
 * @param {String} prefix Api key prefix. Defaults to 'input_footprint'.
 */
export default (params, prefix = 'input_footprint') => (dispatch, getState) => {
  const update = keys(params)
    .reduce((updating, key) => {
      const apiKey = prefix === '' ? key : `${prefix}_${key}`;
      const rawValue = params[key];
      let value = rawValue;
      if (numericInput.isParseable(value)) {
        value = numericInput.parseAndFormat(value, { autoDecimal: true });
        if (numericInput.endsWithDecimalDelimiter(rawValue)) {
          value += numericInput.getDecimalDelimiter();
        }
        return {
          ...updating,
          [apiKey]: value,
        };
      } else if (rawValue === '') {
        return {
          ...updating,
          [apiKey]: rawValue,
        };
      }
      return updating;
    }, {});
  if (!isEmpty(update)) {
    if (keys(update).every(isTakeActionInput)) {
      computeTakeActionResults(update)(dispatch, getState);
      return;
    }
    computeUserFootprint(update)(dispatch, getState);
  }
};
